<a *ngIf="(isLoggedIn$ | async) === false" class="loginbutton item margin-top-7" routerLink="user/login">
  Login
</a>

<a *ngIf="(isLoggedIn$ | async) === true" class="loginbutton item margin-top-7" (click)="logout()">
  Logout
</a>
